// src/components/deck_subdeck/groupIcons.ts
// Catálogo de ícones Lucide disponíveis para grupos

import {
    // Cardiologia / Vascular
    Heart, HeartPulse, HeartCrack, HeartOff, Snail,
    HeartHandshake, HeartMinus, HeartPlus,
    Activity, Waves, Gauge, Timer, Spline,
    ArrowDownNarrowWide, ArrowUpWideNarrow, ZapOff,
    // Respiratório
    Wind, CloudFog, Cigarette, CigaretteOff, ThermometerSun,
    // Infectologia / Imunologia
    Bug, Biohazard, Shield, ShieldAlert, ShieldCheck,
    // Neurologia / Psiquiatria
    Brain, BrainCircuit, Ghost, Network,
    // Farmacologia / Lab
    Syringe, Pill, FlaskConical, FlaskRound, TestTube, Beaker, Thermometer, ThermometerSnowflake,
    Microscope, Pipette, Droplet, FlameKindling,
    // Genética / Oncologia
    Dna, Radiation, Scan, Ribbon,
    // Ortopedia / Cirurgia / Trauma
    Bone, Scissors, Bandage, Wrench, Minimize2,
    // Clínica / Diagnóstico
    Stethoscope, History, Crosshair, Droplets, Skull,
    Scale, UserRound, PersonStanding,
    // Especialidades
    Eye, Ear, Baby, Venus, Mars, Weight, GlassWater,
    // Emergência
    Zap, Flame, AlertTriangle, Siren,
    // Sistêmico / Evolução
    Globe, RefreshCw, TrendingUp, TrendingDown, Route,
    // Medições
    Ruler, Clock7, Clock, Calendar, CalendarDays,
    // Medicina do Trabalho / Social
    HardHat, Users, HandHeart, UserCheck,
    // Educação / Metodologia
    BookOpen, GraduationCap, FileText, Clipboard, Layers,
    Lightbulb, ListChecks, Puzzle, Award, Star, Target, Bookmark,
    BarChart2, Search, Filter, MessageSquare, HelpCircle, Info, CheckCircle,
    // Organização / Sistema
    Compass, Navigation, Map, Folder, FolderOpen, Database, Server, Archive,
    // Natureza
    Leaf, TreePine, Sprout,
    // Endocrinologia / Hormônios / Reprodução
    Egg, Milk, Candy, CandyOff, Cookie,
    Moon, Sun, Repeat, RefreshCcw,
    Sigma, Atom, Orbit, Cpu, RadioTower, Signal,
    Battery, BatteryLow, BatteryMedium,
    Hexagon, CircleDot, Grid3x3,
    ArrowUpFromLine, ChevronsUp, Merge,
    // Glândulas extra (suprarrenais, tireoide, paratireoide)
    Crown, ToggleRight, LayoutGrid, Banana,
    // Miologia / Osteologia / Cartilagem
    Dumbbell, Magnet, Hammer, Mountain, Trophy,
    Hand, Footprints, Anchor, Link,
    RotateCcw, ArrowBigRight, Snowflake, Workflow,
    // Neurologia / Neurofisiologia / Sentidos
    Drama, Navigation2, Frown,
    ArrowUp, ArrowDown,
    Fingerprint, Headphones, Utensils, Coffee, Reply,
    CircuitBoard, Cable, Factory,
    // Reprodução / Embriologia extra
    DoorOpen, GitFork,

     BugOff,
    Worm,
    Shell,
    Fish,
    Bird,
    Feather,
    Wifi,
    Radio,
    Podcast,
    SatelliteDish,
    TimerOff,
    ArrowLeftRight,
    ChevronsLeftRight,
    Combine,
    Split,
    Waypoints,
    Unlink,
    Slice,
    Blend,
    Ratio,
    Contrast,
    Vegan,
    CircleAlert,
    PlugZap,

} from 'lucide-react';
import { LucideIcon } from 'lucide-react';

export interface GroupIconEntry {
    name: string;
    label: string;
    component: LucideIcon;
}

export const GROUP_ICONS: GroupIconEntry[] = [

    // ══ CARDIOLOGIA / VASCULAR ══
    { name: 'Heart',                label: 'Cardiologia',           component: Heart },
    { name: 'HeartPulse',           label: 'Arritmias / ECG',       component: HeartPulse },
    { name: 'HeartCrack',           label: 'Infarto (IAM)',         component: HeartCrack },
    { name: 'HeartOff',             label: 'PCR / Parada',          component: HeartOff },
    { name: 'HeartHandshake',       label: 'Febre Reumática / Valvopatia', component: HeartHandshake },
    { name: 'HeartMinus',           label: 'Tamponamento / Pericardite', component: HeartMinus },
    { name: 'HeartPlus',            label: 'Endocardite / Miocardite', component: HeartPlus },
    { name: 'Snail',                label: 'Insuficiência Cardíaca', component: Snail },
    { name: 'Gauge',                label: 'Hipertensão Arterial',  component: Gauge },
    { name: 'Spline',               label: 'Condução Elétrica',     component: Spline },
    { name: 'ArrowDownNarrowWide',  label: 'Estenose Valvar',       component: ArrowDownNarrowWide },
    { name: 'ArrowUpWideNarrow',    label: 'Aterosclerose / Aneurisma', component: ArrowUpWideNarrow },
    { name: 'ZapOff',               label: 'Bloqueio / Isquemia',   component: ZapOff },
    { name: 'Timer',                label: 'Tempo-Dependente',      component: Timer },
    { name: 'Route',                label: 'Aterosclerose / Vias',  component: Route },
    { name: 'Droplet',              label: 'Hipertensão / Volemia', component: Droplet },
    { name: 'FlameKindling',        label: 'Febre Reumática',       component: FlameKindling },
    { name: 'Minimize2',            label: 'Tamponamento Cardíaco', component: Minimize2 },

    // ══ RESPIRATÓRIO / PNEUMOLOGIA ══
    { name: 'Wind',                 label: 'Ventilação / Asma',     component: Wind },
    { name: 'CloudFog',             label: 'DPOC / Enfisema',       component: CloudFog },
    { name: 'Waves',                label: 'Edema / Efusão',        component: Waves },
    { name: 'Cigarette',            label: 'Tabagismo',             component: Cigarette },
    { name: 'CigaretteOff',         label: 'Cessação Tabágica',     component: CigaretteOff },
    { name: 'ThermometerSun',       label: 'Pneumonia / Febre',     component: ThermometerSun },

    // ══ INFECTOLOGIA / IMUNOLOGIA ══
    { name: 'Bug',                  label: 'Parasitologia',         component: Bug },

    { name: 'Biohazard',            label: 'Risco Biológico / Sepse', component: Biohazard },
    { name: 'Shield',               label: 'Imunologia',            component: Shield },
    { name: 'ShieldAlert',          label: 'Alerta Imune',          component: ShieldAlert },
    { name: 'ShieldCheck',          label: 'Vacinação / Prevenção', component: ShieldCheck },

    // ══ NEUROLOGIA / PSIQUIATRIA ══
    { name: 'Brain',                label: 'Neurologia',            component: Brain },
    { name: 'BrainCircuit',         label: 'Neurofisiologia',       component: BrainCircuit },
    { name: 'Ghost',                label: 'Saúde Mental',          component: Ghost },
    { name: 'Network',              label: 'Vias Neurais',          component: Network },

    // ══ FARMACOLOGIA / LABORATÓRIO ══
    { name: 'Syringe',              label: 'Medicamento IV',        component: Syringe },
    { name: 'Pill',                 label: 'Farmacologia VO',       component: Pill },
    { name: 'FlaskConical',         label: 'Bioquímica',            component: FlaskConical },
    { name: 'TestTube',             label: 'Laboratório',           component: TestTube },
    { name: 'Beaker',               label: 'Química Clínica',       component: Beaker },
    { name: 'Pipette',              label: 'Hematologia',           component: Pipette },
    { name: 'Thermometer',          label: 'Temperatura',           component: Thermometer },
    { name: 'ThermometerSnowflake', label: 'Hipotermia',            component: ThermometerSnowflake },
    { name: 'Microscope',           label: 'Patologia / Histologia', component: Microscope },

    // ══ GENÉTICA / ONCOLOGIA / RADIOLOGIA ══
    { name: 'Dna',                  label: 'Genética',              component: Dna },
    { name: 'Radiation',            label: 'Oncologia / Radioterapia', component: Radiation },
    { name: 'Scan',                 label: 'Diagnóstico por Imagem', component: Scan },
    { name: 'Ribbon',               label: 'Câncer (Consciência)',  component: Ribbon },

    // ══ ORTOPEDIA / CIRURGIA / TRAUMA ══
    { name: 'Bone',                 label: 'Ortopedia',             component: Bone },
    { name: 'Scissors',             label: 'Cirurgia',              component: Scissors },
    { name: 'Bandage',              label: 'Trauma / Curativo',     component: Bandage },
    { name: 'Wrench',               label: 'Procedimentos',         component: Wrench },

    // ══ CLÍNICA / SEMIOLOGIA / DIAGNÓSTICO ══
    { name: 'Stethoscope',          label: 'Semiologia',            component: Stethoscope },
    { name: 'History',              label: 'Anamnese / Histórico',  component: History },
    { name: 'Crosshair',            label: 'Raciocínio Clínico',    component: Crosshair },
    { name: 'Droplets',             label: 'Volemia / Sangue',      component: Droplets },
    { name: 'Skull',                label: 'Toxicologia',           component: Skull },
    { name: 'Scale',                label: 'Bioética',              component: Scale },
    { name: 'UserRound',            label: 'Paciente',              component: UserRound },
    { name: 'PersonStanding',       label: 'Exame Físico',          component: PersonStanding },
    { name: 'Activity',             label: 'Hemodinâmica / Sinais', component: Activity },

    // ══ ESPECIALIDADES ══
    { name: 'Eye',                  label: 'Oftalmologia',          component: Eye },
    { name: 'Ear',                  label: 'Otorrinolaringologia',  component: Ear },
    { name: 'Baby',                 label: 'Pediatria / Neonatologia', component: Baby },
    { name: 'Venus',                label: 'Ginecologia / Obstetrícia', component: Venus },
    { name: 'Mars',                 label: 'Urologia',              component: Mars },
    { name: 'Weight',               label: 'Endocrinologia',        component: Weight },
    { name: 'GlassWater',           label: 'Nefrologia',            component: GlassWater },

    // ══ EMERGÊNCIA / CUIDADOS INTENSIVOS ══
    { name: 'Zap',                  label: 'Emergência',            component: Zap },
    { name: 'Flame',                label: 'Inflamação / Urgente',  component: Flame },
    { name: 'AlertTriangle',        label: 'Alerta Clínico',        component: AlertTriangle },
    { name: 'Siren',                label: 'SAMU / UTI',            component: Siren },

    // ══ SISTÊMICO / EVOLUÇÃO ══
    { name: 'Globe',                label: 'Sistêmico',             component: Globe },
    { name: 'RefreshCw',            label: 'Recidiva / Cronicidade', component: RefreshCw },
    { name: 'TrendingUp',           label: 'Melhora / Progresso',   component: TrendingUp },
    { name: 'TrendingDown',         label: 'Piora / Declínio',      component: TrendingDown },

    // ══ MEDIÇÕES / TEMPO ══
    { name: 'Ruler',                label: 'Medição / Parâmetro',   component: Ruler },
    { name: 'Clock7',               label: 'Plantão',               component: Clock7 },
    { name: 'Clock',                label: 'Cronológico / Agudo',   component: Clock },
    { name: 'Calendar',             label: 'Cronograma / Crônico',  component: Calendar },

    // ══ MEDICINA DO TRABALHO / CUIDADOS ══
    { name: 'HardHat',              label: 'Medicina do Trabalho',  component: HardHat },
    { name: 'HandHeart',            label: 'Cuidados Paliativos',   component: HandHeart },
    { name: 'UserCheck',            label: 'Condutas / Alta',       component: UserCheck },
    { name: 'Users',                label: 'Equipe Médica',         component: Users },

    // ══ EDUCAÇÃO / METODOLOGIA ══
    { name: 'BookOpen',             label: 'Teoria Médica',         component: BookOpen },
    { name: 'GraduationCap',        label: 'Formação',              component: GraduationCap },
    { name: 'FileText',             label: 'Apostila / Texto',      component: FileText },
    { name: 'Clipboard',            label: 'Protocolo / Caso',      component: Clipboard },
    { name: 'Layers',               label: 'Módulo',                component: Layers },
    { name: 'Lightbulb',            label: 'Insight / Core',        component: Lightbulb },
    { name: 'ListChecks',           label: 'Checklist',             component: ListChecks },
    { name: 'Puzzle',               label: 'Integração',            component: Puzzle },
    { name: 'Award',                label: 'Maestria',              component: Award },
    { name: 'Star',                 label: 'Destaque',              component: Star },
    { name: 'Target',               label: 'Objetivo',              component: Target },
    { name: 'Bookmark',             label: 'Marcador',              component: Bookmark },
    { name: 'BarChart2',            label: 'Estatística',           component: BarChart2 },
    { name: 'Search',               label: 'Investigação',          component: Search },
    { name: 'Filter',               label: 'Filtro Diagnóstico',    component: Filter },
    { name: 'MessageSquare',        label: 'Discussão',             component: MessageSquare },
    { name: 'HelpCircle',           label: 'Dúvida',                component: HelpCircle },
    { name: 'Info',                 label: 'Informação',            component: Info },
    { name: 'CheckCircle',          label: 'Concluído',             component: CheckCircle },

    // ══ ORGANIZAÇÃO / SISTEMA ══
    { name: 'Folder',               label: 'Pasta',                 component: Folder },
    { name: 'FolderOpen',           label: 'Pasta Aberta',          component: FolderOpen },
    { name: 'Archive',              label: 'Arquivo',               component: Archive },
    { name: 'Database',             label: 'Banco de Dados',        component: Database },
    { name: 'Server',               label: 'Servidor',              component: Server },
    { name: 'Compass',              label: 'Orientação',            component: Compass },
    { name: 'Navigation',           label: 'Navegação',             component: Navigation },
    { name: 'Map',                  label: 'Mapa de Estudo',        component: Map },

    // ══ NATUREZA ══
    { name: 'Leaf',                 label: 'Botânica / Fitoterápico', component: Leaf },
    { name: 'TreePine',             label: 'Ecologia / Saúde Amb.', component: TreePine },
    { name: 'Sprout',               label: 'Crescimento',           component: Sprout },

    // ══ ENDOCRINOLOGIA / HORMÔNIOS ══
    { name: 'Sigma',                label: 'Tireoide / Hormônios / Dosagem', component: Sigma },
    { name: 'Atom',                 label: 'Hormônio Molecular',    component: Atom },
    { name: 'Orbit',                label: 'Eixo Hormonal / Feedback', component: Orbit },
    { name: 'Cpu',                  label: 'Hipotálamo / Centro Regulador', component: Cpu },
    { name: 'RadioTower',           label: 'Hipófise / Sinais Hormonais', component: RadioTower },
    { name: 'Signal',               label: 'Sinalização Endócrina', component: Signal },
    { name: 'FlaskRound',           label: 'Dosagem Hormonal',      component: FlaskRound },
    { name: 'CircleDot',            label: 'Folículo / Nódulo Tireoidiano', component: CircleDot },
    { name: 'Hexagon',              label: 'Estrutura Hormonal',    component: Hexagon },

    // ══ PÂNCREAS / DIABETES / INSULINA ══
    { name: 'Cookie',               label: 'Glicose / Metabolismo', component: Cookie },
    { name: 'Candy',                label: 'Açúcar / Hiperglicemia', component: Candy },
    { name: 'CandyOff',             label: 'Diabetes / Controle Glicêmico', component: CandyOff },
    { name: 'Battery',              label: 'Energia Celular / ATP', component: Battery },
    { name: 'BatteryLow',           label: 'Hipoglicemia',          component: BatteryLow },
    { name: 'BatteryMedium',        label: 'Insulina / Regulação',  component: BatteryMedium },

    // ══ CRESCIMENTO / DESENVOLVIMENTO ══
    { name: 'ArrowUpFromLine',      label: 'GH / Crescimento',      component: ArrowUpFromLine },
    { name: 'ChevronsUp',           label: 'Desenvolvimento',        component: ChevronsUp },

    // ══ REPRODUÇÃO / EMBRIOLOGIA / OBSTETRÍCIA ══
    { name: 'Egg',                  label: 'Oócito / Embriologia / Fecundação', component: Egg },
    { name: 'Merge',                label: 'Fecundação / Fusão',    component: Merge },
    { name: 'Milk',                 label: 'Lactação / Ocitocina / Prolactina', component: Milk },
    { name: 'Moon',                 label: 'Ciclo Menstrual',        component: Moon },
    { name: 'Sun',                  label: 'Ovulação / Fase Lútea', component: Sun },
    { name: 'CalendarDays',         label: 'Ciclo / Menstruação',    component: CalendarDays },
    { name: 'Repeat',               label: 'Ciclo Hormonal',         component: Repeat },
    { name: 'RefreshCcw',           label: 'Retroalimentação Hormonal', component: RefreshCcw },

    // ══ HISTOLOGIA / ANATOMIA ══
    { name: 'Grid3x3',              label: 'Histologia / Grade Celular', component: Grid3x3 },

    // ══ GLÂNDULAS SUPRARRENAIS / TIREOIDE / PARATIREOIDE ══
    { name: 'Crown',                label: 'Glândulas Suprarrenais',    component: Crown },      // "coroa dos rins" — suprarrenais sentam sobre os rins
    { name: 'Banana',               label: 'Pâncreas',                  component: Banana },     // forma banana do órgão
    { name: 'ToggleRight',          label: 'Tireoide',                  component: ToggleRight },// dois lobos + istmo = toggle
    { name: 'LayoutGrid',           label: 'Paratireoide',              component: LayoutGrid }, // 4 glândulas = 4 células

    // ══ MIOLOGIA / CONTRAÇÃO / OSTEOLOGIA ══
    { name: 'Dumbbell',             label: 'Músculo / Miologia',        component: Dumbbell },
    { name: 'Magnet',               label: 'Contração Muscular',        component: Magnet },     // força actina-miosina
    { name: 'Hammer',               label: 'Ossificação',               component: Hammer },     // construção óssea
    { name: 'Mountain',             label: 'Osso / Tecido Ósseo',       component: Mountain },   // rigidez estrutural
    { name: 'Snowflake',            label: 'Cartilagem Hialina',        component: Snowflake },  // estrutura vítrea/cristalina
    { name: 'Trophy',               label: 'Academia / Treinamento',    component: Trophy },

    // ══ ORTOPEDIA / ANATOMIA LOCOMOTORA ══
    { name: 'Hand',                 label: 'Membros Superiores',        component: Hand },
    { name: 'Footprints',           label: 'Membros Inferiores',        component: Footprints },
    { name: 'Anchor',               label: 'Pelve',                     component: Anchor },     // ancora o corpo
    { name: 'Link',                 label: 'Articulações',              component: Link },       // ligação osso-osso
    { name: 'Workflow',             label: 'Biomecânica',               component: Workflow },   // vetores e fluxo mecânico
    { name: 'RotateCcw',            label: 'Ombro / Rotação',           component: RotateCcw },  // rotação articular
    { name: 'ArrowBigRight',        label: 'Braço / Antebraço',         component: ArrowBigRight },

    // ══ NEUROFISIOLOGIA / VIAS NEURAIS ══
    { name: 'CircuitBoard',         label: 'Encéfalo',                  component: CircuitBoard },// cérebro como circuito complexo
    { name: 'Cable',                label: 'Medula Espinal',            component: Cable },       // cabo principal do SN
    { name: 'Navigation2',          label: 'Cerebelo / Coordenação',    component: Navigation2 },// navegação e equilíbrio
    { name: 'Drama',                label: 'Sistema Límbico',           component: Drama },       // máscaras = emoções
    { name: 'ArrowUp',              label: 'Via Sensitiva (ascendente)', component: ArrowUp },
    { name: 'ArrowDown',            label: 'Via Motora (descendente)',  component: ArrowDown },
    { name: 'Reply',                label: 'Reflexos',                  component: Reply },       // estímulo → resposta imediata
    { name: 'Frown',                label: 'Dor / Nocicepção',          component: Frown },

    // ══ SENTIDOS ESPECIAIS ══
    { name: 'Fingerprint',          label: 'Tato / Sensibilidade',      component: Fingerprint },
    { name: 'Headphones',           label: 'Audição / Via Auditiva',    component: Headphones },
    { name: 'Utensils',             label: 'Gustação',                  component: Utensils },
    { name: 'Coffee',               label: 'Paladar / Flavor',          component: Coffee },

    // ══ HEMATOPOIESE / MEDULA ÓSSEA ══
    { name: 'Factory',              label: 'Medula Óssea / Hematopoiese', component: Factory },  // fábrica de células sanguíneas

    // ══ PARTO / EMBRIOLOGIA AVANÇADA ══
    { name: 'DoorOpen',             label: 'Parto / Trabalho de Parto', component: DoorOpen },   // abertura = nascimento
    { name: 'GitFork',              label: 'Embriologia / Gástrula',    component: GitFork },    // célula → camadas germinativas

    // ══ HEMATOLOGIA / SANGUE / COAGULAÇÃO ══
{ name: 'Slice',            label: 'Corte / Sangramento',                   component: Slice },
{ name: 'Blend',            label: 'Plasma / Componentes do Sangue',        component: Blend },
{ name: 'Ratio',            label: 'Hematócrito / Proporções Sanguíneas',   component: Ratio },
{ name: 'Contrast',         label: 'Hemácia / Oxigenação',                  component: Contrast },
{ name: 'Combine',          label: 'Coagulação / Cascata de Fatores',       component: Combine },
{ name: 'Split',            label: 'Fibrinólise / Dissolução do Coágulo',   component: Split },
{ name: 'Waypoints',        label: 'Fatores de Coagulação (Cascata)',       component: Waypoints },
{ name: 'Unlink',           label: 'Hemofilia / Falha de Coagulação',       component: Unlink },
{ name: 'PlugZap',          label: 'Plaqueta / Ativação Plaquetária',       component: PlugZap },
{ name: 'CircleAlert',      label: 'Lesão Tecidual / Machucado',            component: CircleAlert },

// ══ SINALIZAÇÃO HORMONAL ══
{ name: 'Wifi',             label: 'Sinalização Hormonal Endócrina',        component: Wifi },
{ name: 'Radio',            label: 'Secreção Pulsátil de Hormônio',         component: Radio },
{ name: 'Podcast',          label: 'Eixo Hipotálamo-Hipófise',              component: Podcast },
{ name: 'SatelliteDish',    label: 'Receptor Hormonal de Membrana',         component: SatelliteDish },
{ name: 'ArrowLeftRight',   label: 'Feedback Hormonal Bidirecional',        component: ArrowLeftRight },
{ name: 'ChevronsLeftRight',label: 'Balanço Hormonal / Equilíbrio',         component: ChevronsLeftRight },
{ name: 'TimerOff',         label: 'Hipotireoidismo / Metabolismo Lento',   component: TimerOff },
{ name: 'Vegan',            label: 'Bócio / Nódulo Tireoidiano',            component: Vegan },

// ══ VETORES / PARASITOLOGIA / ENTOMOLOGIA ══
{ name: 'BugOff',           label: 'Mosquito / Vetor / Arbovirose',         component: BugOff },
{ name: 'Bird',             label: 'Vetor Alado / Zoonose',                 component: Bird },
{ name: 'Feather',          label: 'Picada / Inseto Vetor',                 component: Feather },
{ name: 'Worm',             label: 'Helminto / Verme Parasita',             component: Worm },
{ name: 'Shell',            label: 'Caramujo / Hospedeiro Intermediário',   component: Shell },
{ name: 'Fish',             label: 'Peixe / Teníase / Difilobotríase',      component: Fish },
];

// Mapa nome → componente para uso em runtime
export const ICON_MAP: Record<string, LucideIcon> = Object.fromEntries(
    GROUP_ICONS.map(e => [e.name, e.component])
);

export const getIconComponent = (name: string): LucideIcon => {
    return ICON_MAP[name] ?? Layers;
};
